
import { Injectable } from "@angular/core";
import {MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { LoggerService } from "@app/logger/logger.service";
import { lastValueFrom } from "rxjs";
import { UploadFileDialogComponent } from './upload-file-dialog.component';

const log = new LoggerService('UPLOAD FILE SERVICE');

@Injectable({ providedIn: "root" })
export class UploadFileDialogService {

  dialogRef: any;
  /** Nombre del último archivo cargado con el diálogo. */
  lastFileName = '';


  constructor(
    private dialog: MatDialog,
  ) {}
  
  open() {
    let config = new MatDialogConfig();
    this.dialogRef = this.dialog.open(UploadFileDialogComponent,{
      width: '30vw',
      disableClose: true
    });

    return new Promise ((resolve)=>{

      const ref = this.dialogRef;
      // El componente se destruye al cerrar: el nombre se toma antes.
      ref.beforeClosed().subscribe(() => { this.lastFileName = ref.componentInstance?.fileName ?? ''; });
      ref.afterClosed().subscribe((result)=> {
        if(result) resolve(result);
      });
    });
    
  }


}